export const FUNDING_TYPE_ORDER = [
  "Pre-Seed",
  "Seed",
  "Series A",
  "Series B",
  "Series C",
  "Series Unknown",
  "Grant",
  "Undisclosed",
];

export function normalizeFundingStage(type) {
  if (!type || typeof type !== "string") return "Unknown";

  const normalized = type.toLowerCase().replace(/[_-]+/g, " ").trim();

  if (normalized.includes("pre seed")) return "Pre-Seed";
  if (/\bseed\b/.test(normalized)) return "Seed";
  if (normalized.includes("series a")) return "Series A";
  if (normalized.includes("series b")) return "Series B";
  if (normalized.includes("series c")) return "Series C";
  if (normalized.includes("series unknown")) return "Series Unknown";
  if (normalized.includes("grant")) return "Grant";
  if (normalized.includes("undisclosed")) return "Undisclosed";

  return type.trim() || "Unknown";
}
